module.exports = __webpack_public_path__ + "img/font.fb4524dc.svg";